const translationDe = {
  all_projects: "alle Projekte",
  create_project: "Projekte anlegen",
  unassigned: "nicht zugewiesen",
  warnign_alarm: "Warnung/Alarmliste",
  information: "Station Namen",
  map: "Karte",
  warnings: "Warnungen/Alarme",
  events: "Aufzeichnungen",
  visualization: "Visualisierung",
  settings: "Einstellungen",
  devices: "Geräte",
  logout: "Abmelden",
  from: "von",
  to: "zu",
  search: "Suche",
  download_report: "Bericht herunterladen",
  download_zip: "SEG2 Zip herunterladen",
  list_view: "Listenansicht",
  slow_trace: "Hintergrundkanal",
  histogram: "Histogramm",
  norm: "Norm",
  date_time: "Datum/Uhrzeit",
  project: "Projekt",
  station: "Station",
  max: "Maximal",
  max_amplitudes: "Maximale Amplituden",
  dom_frequencies: "DOM-Frequenzen",
  view_visualization: "Visualisierung anzeigen",
  view_details: "Details anzeigen",
  view_single_report: "Einzelnen Bericht anzeigen",
  download_seg2: "Seg2 herunterladen",
  visualization_for: "Visualisierung für",
  trace: "Spur",
  absolute_time: "Absolute Zeit",
  relative_time: "Relative Zeit",
  event: "Ereignis",
  project_name: "Projektname",
  station_name: "Name der Station",
  new_station_name: "Neu Name der Station",
  device_id: "Geräte-ID",
  gps_position: "GPS-Standort",
  project_information: "Projektinformationen",
  network_name: "Netzwerk/Projektname",
  comment: "Kommentar",
  client: "Kunde",
  company: "Unternehmen",
  location: "Standort",
  observer: "Beobachter",
  measurement_setting: "Messeinstellung",
  global_measurement_settings: "Globale Messeinstellungen",
  measurement_unit: "Messeinheit",
  measurement_range: "Messbereich",
  sampling_rate: "Abtastrate [Hz]",
  trace_length: "Aufzeichnungslänge ",
  pretrigger_length: "Prätriggerzeit",
  measurement_gain: "Messverstärkung",
  offset_remover: "Offset-Entferner",
  microphone_channel: "Mikrofonkanal",
  measurement_type: "Art der Messung",
  trigger_level_X: "Auslösestufe X",
  trigger_level_Y: "Auslösestufe Y",
  trigger_level_Z: "Auslösestufe Z",
  trigger_level_VR: "Auslösestufe VR",
  auto_trigger_interval: "Automatisches Auslöseintervall [min]",
  axis_auto_rotation: "Automatische Achsendrehung",
  manual_rotation_X_axis: "Manuelle Drehung X-Achse",
  manual_rotation_Y_axis: "Manuelle Drehung Y-Achse",
  manual_rotation_Z_axis: "Manuelle Drehung Z-Achse",
  background_trace: "Hintergrund/Hintergrundkanal",
  next: "nächste",
  previous: "zurück",
  device_messaging: "Geräte-Benachrichtigung",
  global_device_messaging: "Globale Geräte-Benachrichtigung",
  sms_user_0_number: "Sms Benutzer [0] Nummer",
  sms_user_1_number: "Sms Benutzer [1] Nummer",
  sms_user_2_number: "Sms Benutzer [2] Nummer",
  sms_user_3_number: "Sms Benutzer [3] Nummer",
  sms_user_4_number: "Sms Benutzer [4] Nummer",
  sms_user_5_number: "Sms Benutzer [5] Nummer",
  email_user_0: "E-Mail Benutzer [0]",
  email_user_1: "E-Mail Benutzer [1]",
  email_user_2: "E-Mail Benutzer [2]",
  email_user_3: "E-Mail Benutzer [3]",
  email_user_4: "E-Mail Benutzer [4]",
  email_user_5: "E-Mail Benutzer [5]",
  warning_level: "Warnstufe",
  alarm_level: "Alarmstufe",
  sms_silence_time: "SMS-Ruhezeit",
  message_on: "Nachricht an",
  trigger: "Auslöser",
  warning: "Warnung",
  alarm: "Alarm",
  system: "System",
  weekly: "Wöchentlich",
  monthly: "Monatlich",
  global_server_messaging: "Globale Server-Benachrichtigungen",
  data_transfer: "Datenübertragung",
  global_transfer_settings: "Globale Übertragunseinstellungen",
  data_transmission_network: "Datenübertragungsnetz",
  let_apn: "LTE APN",
  wlan_ssid: "WLAN SSID",
  wlan_passkey: "WLAN-Schlüssel",
  enable_ftp_upload: "FTP/SFTP-Hochladen aktivieren",
  ftp_server: "FTP/SFTP Server",
  ftp_user: "FTP/SFTP Benutzer",
  ftp_password: "FTP/SFTP Kennwort",
  gps_module_enabled: "GPS-Modul aktiviert",
  led_signals: "LED Signale",
  network_data_url: "Netzwerkdaten-URL",
  network_data_ep: "Netzdaten EP",
  network_config_url: "Netzwerk-Konfigurations-Url",
  network_config_ep: "Netzwerkkonfigurations EP",
  network_config_ep_ack: "Netzwerkkonfiguration EP ACK",
  available_devices: "Verfügbare Geräte",
  renting_from: "Vermietung von",
  renting_to: "Vermietung an",
  options: "Optionen",
  abort: "Abbrechen",
  save: "Speichern",
  project_info: "Projektinformationen",
  measurements: "Messungen",
  server_messaging: "Server-Benachrichtigung",
  transfer_other: "Übertragung/Sonstiges",
  assign_devices: "Gerät zuweisen",
  serial_no: "Serien-Nr.",
  user_details: "Benutzer-Details",
  user_email: "Benutzer E-Mail",
  language_setting: "Spracheinstellung",
  timezone: "Zeitzone",
  summer_winter: "Sommer/Winter",
  update_password: "Passwort aktualisieren",
  user_settings: "Benutzereinstellungen",
  save_user_settings: "Benutzereinstellungen speichern",
  current_password: "Aktuelles Passwort",
  new_password: "Neues Passwort",
  confirm_new_password: "Neues Passwort bestätigen",
  cancel: "Abbrechen",
  sub_accounts: "Unterkonten",
  sub_account_permissions: "Unterkonto und Berechtigungen",
  login_name: "Login Name",
  other_information_available: "Andere Informationen verfügbar",
  permission: "Berechtigungen",
  projects: "Projekte",
  add_edit_users: "Benutzer hinzufügen/bearbeiten",
  add_edit_projects: "Projekt hinzufügen/bearbeiten",
  assign_projects: "Projekte zuweisen",
  project_permissions: "Projekt-Berechtigungen",
  edit_devices: "Geräte bearbeiten",
  create_reports: "Berichte erstellen",
  view_data: "Daten anzeigen",
  showing: "Zeigen",
  file_downloaded: "Die Datei wird gerade heruntergeladen, bitte warten Sie",
  device_detail: "Geräte-Details",
  start_time: "Startzeit",
  end_time: "Endzeit",
  firmware_version: "Firmware-Version",
  current_pass_error: "Bitte aktuelles Passwort eingeben!",
  current_pass_no_find: "Das aktuelle Passwort ist nicht korrekt!",
  new_pass_error: "Bitte neues Passwort eingeben!",
  confirm_pass_error: "Bitte geben Sie Ihr Passwort ein!",
  pass_no_match:
    "Neues Passwort und Passwort bestätigen stimmen nicht überein!",
  add_edit: "Hinzufügen/Bearbeiten",
  users: "Benutzer",
  edit: "Bearbeiten",
  reports: "Berichte",
  create: "erstellen",
  view: "Siehe",
  data: "Daten",
  project_field: "Bitte füllen Sie das Feld Projektname aus",
  server_messaging_setting: "Server-Nachrichteneinstellungen",
  email_silence_time: "E-Mail-Ruhezeit",
  automatic_report: "Automatischer Bericht über",
  assign: "zuweisen",
  assigned_device: "Zugewiesene Geräte",
  attention: "ACHTUNG",
  attention_message:
    "Wenn das Projekt gespeichert wird, werden alle globalen Einstellungen auf die zugewiesenen Geräte übertragen und die Gerätekonfiguration wird aktualisiert.",
  all_available_devices: "Alle verfügbaren Geräte",
  event_report: "Bericht über die Veranstaltung",
  compliance_report: "Compliance-Bericht",
  measurement_information: "Informationen zur Messung",
  channel_name: "Kanal Name",
  maxima: "Maxima",
  time_maxima: "Zeitpunkt des Maxima",
  frequency: "Frequenz",
  peak_displacement: "max. Schwingweg",
  peak_acceleration: "Maximale Beschleunigung",
  download_event_list: "Download mit Veranstaltungsliste",
  downlaod_without_event_list: "Download ohne Veranstaltungsliste",
  fname: "Vorname",
  lname: "Nachname",
  username: "Benutzername",
  email: "Email",
  password: "Passwort",
  confirm_password: "Bestätigen Sie Ihr Passwort",
  fname_error: "Bitte Vornamen eingeben",
  lname_error: "Bitte Nachnamen eingeben",
  email_error: "Bitte E-Mail eingeben",
  username_error: "Bitte Benutzernamen eingeben",
  password_error: "Bitte Passwort eingeben",
  confirm_password_error: "Bitte Passwort bestätigen",
  password_match_error:
    "Kennwort und Bestätigungskennwort stimmen nicht überein",
  role_error: "Bitte wählen Sie mindestens eine Benutzerrolle",
  username_email_found: "Der Benutzername oder die E-Mail existiert bereits",
  view_report: "Bericht anzeigen",
  select_event: "Ereignisse auswählen",
  select_project: "Projekt auswählen",
  device_deleted: "Das ausgewählte Gerät wurde aus dem Projekt gelöscht!",
  something_wrong: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später!",
  project_created:
    "Das Projekt ist erstellt und die Geräte sind zugewiesen worden!",
  project_updated:
    "Das Projekt wurde aktualisiert und die Geräte wurden zugewiesen!",
  session_expired: "Sitzung Abgelaufen",
  session_expired_message:
    "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an",
  station_name_exist: "Station Name existiert bereits!",
  station_name_empty: "Bitte geben Sie den Namen der Station an",
  assign_project_setting: "Die Projekteinstellungen zuweisen?",
  project_deleted: "Das Projekt wurde gelöscht!",
  yes: "Ja",
  no: "Nein",
  project_select:
    "Bitte wählen Sie das Projekt aus, das dem ausgewählten Gerät zugewiesen werden soll",
  device_assigned: "Das Gerät wird dem ausgewählten Projekt zugewiesen",
  delete_dialoge_message: "Möchten Sie dieses Gerät mit der ID",
  delete_confirmation: "Bestätigung löschen",
  device_updated: "Das Gerät wurde aktualisiert",
  slow_trace_graph: "Hintergrundkanal",
  relative_timein: "Relative Zeit in",
  project_delete_message: "Möchten Sie das Projekt mit dem Namen",
  correct_date:
    "Bitte wählen Sie das richtige Datum und die richtige Zeitspanne",
  download_csv: "Exportieren nach CSV",
  setting_updated: "Die Benutzereinstellungen wurden aktualisiert!",
  power_save: "Strom sparen",
  traceLength_error: "Bitte füllen Sie das Feld Tracelänge aus",
  pretriggerLength_error:
    "Bitte füllen Sie das Feld für die Länge des Pretriggers aus",
  triggerX_error: "TriggerX kann nicht 0 oder kleiner als 0 sein",
  triggerY_error: "TriggerY kann nicht 0 oder kleiner als 0 sein",
  triggerZ_error: "TriggerY kann nicht 0 oder kleiner als 0 sein",
  autoTrigger_error: "Auto-Trigger sollte mindestens 0 sein",
  samplingRate_error: "Bitte wählen Sie die Abtastrate",
  slow_trace_error: "Bitte langsame Verfolgung anbieten",
  microphone_error: "Bitte wählen Sie einen Mikrofonkanal",
  powersave_error: "Bitte wählen Sie Energiesparen",
  projectName_error: "Bitte füllen Sie das Feld Projektname aus",
  norm_error: "Bitte Normfeld ausfüllen",
  graphical_overview: "Grafische Übersicht der Ereignisse auf Zeitbasis.",
  tracelength_greater_error:
    "Die Tracelänge sollte größer sein als die Pretriggerlänge",
  last_day: "24 Stunden",
  last_week: "Letzte 7 Tage",
  last_10_days: "Letzte 10 Tage",
  last_14_days: "Letzte 14 Tage",
  last_month: "Letzter 1 Monat",
  last_2_month: "Letzter 2 Monat",
  project_cancelled: "Die Einstellungen wurden gelöscht",
  deleted_project: "Abgeschlossene Projekte",
  restore_project_header: "Projekt wiederherstellen",
  restore_project: "Möchten Sie das folgende Projekt wiederherstellen",
  restore_project_message: "Das Projekt wurde wiederhergestellt",
  email_check: "Bitte prüfen Sie Ihre E-Mail auf den Download-Link",
  slow_trace_report: "Slow Trace Bericht",
  date: "Datum",
  data_station: "Bitte wählen Sie einen Stationsnamen mit Daten",
  update_station: "Update-Station",
  current_station_name: "Aktuelle Station",
  new_station: "Neue Station",
  station_updated: "Die Station wurde aktualisiert",
  station_name_error: "Bitte füllen Sie das Feld Stationsname aus",
  station_name_special_char_error:
    "Bitte verwenden Sie keine Sonderzeichen im Stationsnamen",
  sms0_error: "Bitte sms 0 Nummernfeld ausfüllen",
  sms1_error: "Bitte sms 1 Nummernfeld ausfüllen",
  sms2_error: "Bitte sms 2 Nummernfeld ausfüllen",
  sms3_error: "Bitte sms 3 Nummernfeld ausfüllen",
  sms4_error: "Bitte sms 4 Nummernfeld ausfüllen",
  sms5_error: "Bitte sms 5 Nummernfeld ausfüllen",
  email0_error: "Bitte E-Mail ausfüllen 0 Nummernfeld",
  email1_error: "Bitte E-Mail ausfüllen 1 Nummernfeld",
  email2_error: "Bitte E-Mail ausfüllen 2 Nummernfeld",
  email3_error: "Bitte E-Mail ausfüllen 3 Nummernfeld",
  email4_error: "Bitte E-Mail ausfüllen 4 Nummernfeld",
  email5_error: "Bitte E-Mail ausfüllen 5 Nummernfeld",
  item_selected: "ausgewählte Artikel",
  change_slow_trace: "Wechsel zum langsamen Tracediagramm",
  change_bar_graph: "Zu Balkendiagramm wechseln",
  linear: "Lineare Skala",
  logarithmic: "Logarithmische Skala",
  select_norm: "Norm auswählen",
  no_data: "Es sind keine Daten verfügbar.",
  project_exist: "Projektname existiert bereits",
  trigger_level: "Auslösepegel",
  vector_sum: "Vektorsumme",
  previous_event: "Vorherige Veranstaltung",
  next_event: "Nächste Veranstaltung",
  delete: "löschen",
  lte_apn_error: "Bitte das Feld LTE APN ausfüllen",
  data_url_error: "Bitte füllen Sie das Url-Feld aus",
  data_ep_error: "Bitte füllen Sie das Feld Ep aus",
  config_url_error: "Bitte füllen Sie das Feld config Url aus",
  config_ep_error: "Bitte füllen Sie das Feld EP aus",
  config_ep_ack_error: "Bitte das Feld EP ACK ausfüllen",
  field_name: "Feldname",
  input: "Eingabe",
  communication_param: "Kommunikationsparameter",
  ftp_option: "optionaler FTP/SFTP Datentransfer",
  cloud_stand: "Cloud Zugangsdaten",
  gps_settings: "GPS-Einstellungen",
  custom_time: "Benutzerdefinierte Zeit",
  din_plot: "DIN-Plot-Diagramm",
  traceLength_limit_error:
    "Die Tracelänge sollte größer als gleich 10[s] und kleiner als gleich 120[s] sein.",
  preTriggerLength_limit_error:
    "Pre Trigger Length sollte größer als gleich 0[s] und kleiner als gleich 119[s] sein",
  in_progress: "In Entwicklung",
  warning_error: "Warnstufe sollte niedriger sein als die Alarmstufe",
};
export default translationDe;
